import React, {Component} from 'react';
import {Link, Redirect} from "react-router-dom";
import Recipients from "./Recipients.js";
import * as AppConstant from '../common/AppConstant'
import Errors from '../common/Errors';
import InvalidAccessOrLogin from "../errorsPage/InvalidAccessOrLogin";

class GetSignature extends Component {

    state = {
        id: null,
        templates:[],
        rdr : false,
        selectedTemplateId:'',
        selectedTemplate:{},
        blubillingConf:{},
        selectedTemplateIdErrorMsg: '',
        selectedTemplateElementName:[],
        disableExportCustomer:false,
        eitherAchOrCardRequired:false,
        enableSigningOrder:false,
        doNotEmailAttachment:false,
        processPaymentAfterSigning:'0',
        globalEnableSigningOrder:false,
        globalProcessPaymentAfterSigning:false,
        enableRequesterAsRecipient:false,
        createOrderOnSigning:false,
        createInvoice: false,
        allowCreateOrder: false,
        showDiv:false,
        recipients: [
            {
                index: 0,
                name: '',
                role: '',
                email: '',
                scope: 'Signer',
                elements:[],
                isRequester:false,
                orderValue:null,
                enabledSigningOrder: false,
                selectedTemplateElementNameByRecipient:[],
                nameError: false,
                nameErrorMsg: '',

                emailError: false,
                emailErrorMsg: '',

                scopeError: false,
                scopeErrorMsg: '',

                elementsError: false,
                elementErrorMsg: ''
            }
        ],
        emailTitle: '',
        emailTitleError: '',

        description: '',
        descriptionError: '',
        rediretPage: '',
        apiStatus: {
            isError: true,
            message: '',
            messages: []
        },
        redirectToList:true,
        draftStatus:true,
        staff:{},
        showLoader:false,
        redirectToForbiddenPage: false,
        docTemplateRecipients: []
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.handleRemoveRow = this.handleRemoveRow.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRecipientNameChange = this.handleRecipientNameChange.bind(this);
        this.handleRecipientEmailChange = this.handleRecipientEmailChange.bind(this);
        this.handleRecipientScopeChange = this.handleRecipientScopeChange.bind(this);
        this.handleRecipientElementNameChange = this.handleRecipientElementNameChange.bind(this);
        this.handleRecipientIsRequesterChange = this.handleRecipientIsRequesterChange.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.fetchAllActiveTemplates = this.fetchAllActiveTemplates.bind(this);
        this.fetchLoggedInStaff = this.fetchLoggedInStaff.bind(this);
        this.onChangeTemplate = this.onChangeTemplate.bind(this)
        this.validateDraggedelementName = this.validateDraggedelementName.bind(this);
        this.handleRecipientAccessCodeChange = this.handleRecipientAccessCodeChange.bind(this);
        this.handleDraftStatus = this.handleDraftStatus.bind(this);
        this.createRecipient = this.createRecipient.bind(this);
        this.fetchSignatureSetting = this.fetchSignatureSetting.bind(this)
        this.fetchBlubillingSetting = this.fetchBlubillingSetting.bind(this)
        this.onOrderValueChange = this.onOrderValueChange.bind(this)
        this.changeOrderValueOfAllRecipient = this.changeOrderValueOfAllRecipient.bind(this);
        this.fetchDraggedElementAfterGettingTemplateFromId = this.fetchDraggedElementAfterGettingTemplateFromId.bind(this)
        this.moveUp = this.moveUp.bind(this)
        this.moveDown = this.moveDown.bind(this);
        this.handleShowAdvanceOptions = this.handleShowAdvanceOptions.bind(this);
        this._swap = this._swap.bind(this)
    }

    fetchBlubillingSetting(selectedTemplate)  {
        if(selectedTemplate){
            fetch(this.props.api + '/blubillingConf', {
                method: "GET",
                mode: 'cors',
                headers: {
                    "X-AUTH-TOKEN": this.props.jwtToken,
                    'content-type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(json => {
                    if (json && json.isError === false) {
                        const blubillingConfiguration = json.blubillingConfiguration;
                        this.setState({blubillingConf: blubillingConfiguration});
                        if (blubillingConfiguration && blubillingConfiguration.enableCreateCustomer === true) {
                            this.setState({
                                globalEnableCreateCustomer: true,
                                disableExportCustomer: selectedTemplate.disableExportCustomer})
                        }
                        if(blubillingConfiguration && blubillingConfiguration.enableCreateCustomer !== true){
                            this.setState({
                                globalEnableCreateCustomer: false,
                                disableExportCustomer: true})
                        }
                        if (blubillingConfiguration && blubillingConfiguration.enablePayments === true) {
                            this.setState({
                                globalProcessPaymentAfterSigning: true,
                                processPaymentAfterSigning: selectedTemplate.processPaymentAfterSigning
                            })
                        }
                        if (blubillingConfiguration && blubillingConfiguration.enablePayments !== true) {
                            this.setState({
                                globalProcessPaymentAfterSigning: false,
                                processPaymentAfterSigning: 'DISABLED'
                            })
                        }
                        if (blubillingConfiguration && blubillingConfiguration.allowCreateOrder === true) {
                            this.setState({
                                allowCreateOrder: true, createOrderOnSigning: selectedTemplate.createOrderOnSigning,
                                createInvoice: selectedTemplate.createInvoice
                            })
                        }
                        if (blubillingConfiguration && blubillingConfiguration.allowCreateOrder !== true) {
                            this.setState({allowCreateOrder: false, createOrderOnSigning: false, createInvoice: false})
                        }
                    } else {
                        if (json && json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                            this.props.onLogoutClick(json.message);
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
    componentDidMount(){
        this.fetchLoggedInStaff();
    }

    fetchAllActiveTemplates(){
        var anotherThizz = this;
        this.setState({showLoader:true});
        this.fetchAllRecipients(this.props.tid.id)
        fetch(this.props.api + '/template?fetch=all', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json)
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                    this.setState({showLoader: false, redirectToForbiddenPage: true});
                } else {
                    this.setState({templates: json});
                    if(anotherThizz.props.tid && AppConstant.validateValue(anotherThizz.props.tid.id,"S") === true){
                        var res = json.filter(function(item) {
                            return item.id == anotherThizz.props.tid.id;
                        });
                        if(res && res[0]){
                            console.log("res[0]   fetchAllActiveTemplates ",res[0]);
                            anotherThizz.setState({
                                description: res[0].description,
                                emailTitle: res[0].templateName,
                                selectedTemplate:res[0]
                            });
                            anotherThizz.setState({
                                disableExportCustomer: res[0].disableExportCustomer == true ? true : false,
                                eitherAchOrCardRequired: res[0].eitherAchOrCardRequired === true ? true : false,
                                enableRequesterAsRecipient:res[0].enableRequesterAsRecipient === true ? true : false,
                                createOrderOnSigning: res[0].createOrderOnSigning  === true ? true : false,
                                createInvoice: res[0].createInvoice === true ? true : false,
                                doNotEmailAttachment: res[0].doNotEmailAttachment === true ? true : false
                            });

                            if (res[0]) {
                                anotherThizz.fetchBlubillingSetting(res[0]);
                            }

                            if(res[0] && res[0].enableSigningOrder){
                                anotherThizz.setState({enableSigningOrder: true});
                                anotherThizz.fetchSignatureSetting(res[0].enableSigningOrder);
                            }
                            else{
                                if(anotherThizz.state.globalEnableSigningOrder){
                                    anotherThizz.setState({enableSigningOrder: false});
                                    anotherThizz.changeOrderValueOfAllRecipient()
                                }else{
                                    anotherThizz.setState({enableSigningOrder: false, globalEnableSigningOrder: false});
                                    anotherThizz.changeOrderValueOfAllRecipient()
                                }
                            }
                            anotherThizz.fetchDraggedElementAfterGettingTemplateFromId()
                        }
                    }
                }
                this.setState({showLoader:false});
            }).catch(error =>{
            console.log(error);
            this.setState({showLoader:false});
        });
    }
    fetchAllRecipients(tmpId){
        fetch(this.props.api + '/template/'+tmpId+'/recipients', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                    console.debug("docTemplateRecipients json")
                    console.log(json)
                    this.setState({docTemplateRecipients: json.properties.docTemplateRecipients})
                    console.log('Doc Recipients'+this.state.docTemplateRecipients[0].recipientNumber)
                }

            );
    }

    fetchDraggedElementAfterGettingTemplateFromId(){
        if (this.props.tid && AppConstant.validateValue(this.props.tid.id, "S") === true) {
            this.setState({selectedTemplateElementName: [], selectedTemplateId: this.props.tid.id, showLoader: true});
            fetch(this.props.api + '/template/' + this.props.tid.id + '/draggedElements', {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken
                }
            })
                .then(response => response.json())
                .then(json => {
                    console.log(json)
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    }else{
                        let length = json.length;
                        json.map((data,index) => {
                            let keyValue = 'recipient' + parseInt((parseInt(index, 10) + 1), 10);
                            let arr = [];
                            arr.push(keyValue);
                            var selectedTemplateElementNameByRECIPIENT;
                            arr.map( (recipientDraggedElements, index) => {
                                selectedTemplateElementNameByRECIPIENT = data[recipientDraggedElements]
                                return null;
                            });
                            if (selectedTemplateElementNameByRECIPIENT !== undefined) {
                                this.createRecipient(index, arr.map(keyValue => data[keyValue]), length);
                            }
                            return null;
                        });
                    }
                    this.setState({showLoader: false});
                }).catch(error => {
                console.log(error);
                this.setState({showLoader: false});
            });

        }
        if (this.state.selectedTemplate && this.state.selectedTemplate.enableSigningOrder) {
            this.setState({enableSigningOrder: true});
            this.fetchSignatureSetting(this.state.selectedTemplate.enableSigningOrder);
        }
        else {
            if (this.state.globalEnableSigningOrder) {
                this.changeOrderValueOfAllRecipient();
                this.setState({enableSigningOrder: false});
            } else {
                this.changeOrderValueOfAllRecipient();
                this.setState({enableSigningOrder: false, globalEnableSigningOrder: false});
            }
        }
    }
    fetchLoggedInStaff(){
        this.setState({showLoader:true});
        let thizz = this
        fetch(this.props.api + '/staff/currentUser', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json)
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                }else{
                    this.setState({staff: json.staff}, function(){
                        thizz.fetchAllActiveTemplates();
                    })
                }
                this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
            this.setState({showLoader:false})
        });
    }


    fetchSignatureSetting(settingEnabled) {
        console.log("Setting enabled "+ settingEnabled)
        if(settingEnabled === true){
            this.setState({showLoader:true});
            fetch(this.props.api + '/signatureSetting', {
                method: "GET",
                mode: 'cors',
                headers: {
                    "X-AUTH-TOKEN": this.props.jwtToken,
                    'content-type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(json => {
                    console.log(json);
                    if (json.isError === false){
                        const signatureSetting = json.signatureSetting;
                        if(signatureSetting && signatureSetting.enableSigningOrder === true){
                            this.setState({globalEnableSigningOrder: true});
                        }
                    }else{
                        this.changeOrderValueOfAllRecipient();
                        this.setState({enableSigningOrder: false, globalEnableSigningOrder: false});
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.setState({showLoader:false});
                });
        }
    }
    onChangeTemplate(event){
        let _this = this;
        var idT = event.target.value;
        this.setState({showLoader:true});
        this.setState({selectedTemplateId:event.target.value,selectedTemplateElementName:[]})
        this.fetchAllRecipients(event.target.value)

        fetch(this.props.api + '/template/'+event.target.value+'/draggedElements', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.props.onLogoutClick(json.message);
                }else{
                    if(idT && AppConstant.validateValue(idT,"S") === true){
                        var res = this.state.templates.filter(function(item) {
                            return item.id == idT;
                        });
                        if(res && res[0]){
                            console.log("res[0] change template   ",res[0]);
                            _this.setState({
                                description: res[0].description,
                                emailTitle: res[0].templateName,
                                disableExportCustomer: res[0].disableExportCustomer == true ? true : false,
                                eitherAchOrCardRequired: res[0].eitherAchOrCardRequired === true ? true : false,
                                enableRequesterAsRecipient: res[0].enableRequesterAsRecipient === true ? true : false,
                                createOrderOnSigning: res[0].createOrderOnSigning === true ? true : false,
                                createInvoice: res[0].createInvoice === true ? true : false,
                                doNotEmailAttachment: res[0].doNotEmailAttachment === true ? true : false
                            });
                            if (res[0]) {
                                _this.fetchBlubillingSetting(res[0]);
                            }
                            if(res[0] && res[0].enableSigningOrder){
                                this.setState({enableSigningOrder: true});
                                this.fetchSignatureSetting(res[0].enableSigningOrder);
                            }else{
                                if(this.state.globalEnableSigningOrder){
                                    this.changeOrderValueOfAllRecipient()
                                    this.setState({enableSigningOrder: false});
                                }else{
                                    this.changeOrderValueOfAllRecipient()
                                    this.setState({enableSigningOrder: false, globalEnableSigningOrder: false});
                                }
                            }
                        }
                    }

                    this.setState({recipients: [
                            {
                                index: 0,
                                name: '',
                                role:'',
                                email: '',
                                scope: 'Signer',
                                elements:[],
                                isRequester:false,
                                orderValue:null,
                                enabledSigningOrder:_this.state.enableSigningOrder,
                                selectedTemplateElementNameByRecipient:[],
                                nameError: false,
                                nameErrorMsg: '',

                                emailError: false,
                                emailErrorMsg: '',

                                scopeError: false,
                                scopeErrorMsg: '',

                                elementsError: false,
                                elementErrorMsg: ''
                            }
                        ]});
                    let length = json.length;
                    json.map((data,index) => {
                        let keyValue ='recipient'+parseInt((parseInt(index, 10)+1), 10);
                        let arr = [];
                        arr.push(keyValue);
                        var selectedTemplateElementNameByRECIPIENT;
                        arr.map((recipientDraggedElements, index) => {
                            selectedTemplateElementNameByRECIPIENT = data[recipientDraggedElements]
                            return null;
                        });
                        if (selectedTemplateElementNameByRECIPIENT !== undefined) {
                            this.createRecipient(index, arr.map(keyValue => data[keyValue]), length);
                        }
                        return null;
                    });

                }
                this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
            this.setState({showLoader:false});
        });
    }

    createRecipient(key, selectedTemplateElementNameForRec, lnth) {
        console.log("key ", key, "recipients[0] ", this.state.recipients[0],
            "enableRequesterAsRecipient ", this.state.enableRequesterAsRecipient);
        const {recipients} = this.state;
        const {docTemplateRecipients} = this.state;
        console.log("docTemplateRecipients::"+key)
        console.log(docTemplateRecipients)
        let recipient = [];
        docTemplateRecipients.forEach((docRecipient) => {
            if(docRecipient.recipientNumber===(key+1)){
                recipient=docRecipient
            }
        });
        console.log("recipient")
        console.log(recipient)
        let eachRec = {
            index: key,
            name:'',
            role: '',
            email: '',
            scope: 'Signer',
            isRequester: false,
            orderValue: parseInt(key + 1, 10),
            enabledSigningOrder: this.state.enableSigningOrder,
            elements: selectedTemplateElementNameForRec[0],
            selectedTemplateElementNameByRecipient: selectedTemplateElementNameForRec[0],
            nameError: false,
            nameErrorMsg: '',
            emailError: false,
            emailErrorMsg: '',

            scopeError: false,
            scopeErrorMsg: '',

            elementsError: false,
            elementErrorMsg: ''
        };

        if(key === 0) {
            if(recipient.scope==="Requester"){
                recipients[0].name=this.state.staff.fullName
                recipients[0].email=this.state.staff.emailPrimary
                recipients[0].scope= recipient.scope;
                recipients[0].isRequester=true
            }
            else{
                recipients[0].name= recipient.scope ===("Signer" || "CC")? "":recipient.name;
                recipients[0].email= recipient.email;
                recipients[0].role= recipient.scope ===("Signer" || "CC")? recipient.name:"";
                recipients[0].scope= recipient.scope;
                recipients[0].roleName = recipient.roleName;
            }

            recipients[0].selectedTemplateElementNameByRecipient = selectedTemplateElementNameForRec[0];
            recipients[0].elements= selectedTemplateElementNameForRec[0];
            recipients[0].enabledSigningOrder = this.state.enableSigningOrder;
            recipients[0].orderValue = parseInt(key + 1, 10);
        }
        if (this.state.enableRequesterAsRecipient && this.state.staff && this.state.staff.fullName && (key === (lnth - 1))) {
            eachRec.name = this.state.staff.fullName
            eachRec.email = this.state.staff.emailPrimary
            eachRec.isRequester = this.state.enableRequesterAsRecipient;
        }
        if(key !== 0) {
            if(recipient.scope==="Requester"){
                eachRec.name = this.state.staff.fullName
                eachRec.email = this.state.staff.emailPrimary
                eachRec.scope="Requester"
                eachRec.isRequester=true
            }
            else if(recipient.scope==="Signer"||recipient.scope==="CC"){
                eachRec.name = "";
                eachRec.email = recipient.email
                eachRec.role= recipient.name;
                eachRec.scope=recipient.scope
                eachRec.roleName = eachRec.roleName;
            }
            else{
                eachRec.name = recipient.name;
                eachRec.email = recipient.email
                eachRec.role= "";
                eachRec.scope=recipient.scope
                eachRec.roleName = eachRec.roleName;
            }
            recipients.push(eachRec);
        }
        this.setState({
            recipients: recipients
        });
    }

    handleDraftStatus(value){
        console.log("value== "+value);
        this.setState({redirectToList: value});
    }



    changeOrderValueOfAllRecipient(){
        let {recipients} = this.state;
        recipients.forEach((recipient) => {
            recipient.orderValue = null
        });
        this.setState({recipients: recipients});
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }
    checkBoxChange(value, name) {
        console.log("value="+value+", name="+name);
        if (value === true) {
            this.setState({[name]: false});
            if("enableSigningOrder" === name){
                let {recipients} = this.state;
                recipients.forEach((recipient) => {
                    console.log("recipient.orderValue", recipient.orderValue)
                    recipient.orderValue = null
                    recipient.enabledSigningOrder = false;
                });
                this.setState({recipients: recipients});
            }
        } else {
            this.setState({[name]: true});
            if("enableSigningOrder" === name){
                let {recipients} = this.state;
                let count = 1;
                recipients.forEach((recipient) => {
                    console.log("count", count)
                    recipient.orderValue = (count);
                    recipient.enabledSigningOrder = true;
                    count += 1;
                });
                this.setState({recipients: recipients});
            }

        }
    }

    changeRadioButton(value, name){
        this.setState({[name]: value});
    }

    handleRecipientNameChange(index, value) {
        let recipients = this.state.recipients.slice(0);
        recipients[index].name = value;
        recipients[index].nameError =  false;
        recipients[index].nameErrorMsg =  '';
        if(typeof value !== "string" || value === '') {
            recipients[index].nameError =  true;
            recipients[index].nameErrorMsg =  'Name of Recipients is invalid';
        }
        this.setState({recipients: recipients});
    }
    handleRecipientAccessCodeChange(index, value){
        const {recipients} = this.state;
        var name = "accessCode";
        const recipientsWithIndex = recipients[index];
        if(recipientsWithIndex.accessCode === '' || recipientsWithIndex.accessCode === undefined || recipientsWithIndex.accessCode === null) {
            fetch(this.props.api + '/signature/randomNumber', {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken
                }
            })
                .then(response => response.json())
                .then(json => {
                    console.log(json);
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    }else{
                        recipientsWithIndex[name] = json.accessCode;
                        recipients[index] = recipientsWithIndex;
                        this.setState({recipients: recipients});
                    }
                }).catch(error => {
                console.log(error)
                this.setState({showLoader:false});
            });
        }else{
            recipientsWithIndex[name] =  '';
            recipients[index] = recipientsWithIndex;
            this.setState({recipients: recipients});
        }
    }

    handleRecipientEmailChange(index, value) {
        const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let recipients = this.state.recipients.slice(0);
        recipients[index].email = value;
        recipients[index].emailError = false;
        recipients[index].emailErrorMsg = '';
        if(typeof value !== "string" || value === '' || !emailPattern.test(value.toLowerCase())) {
            recipients[index].emailError = true;
            recipients[index].emailErrorMsg = 'Email of Recipient is invalid';
        }
        this.setState({recipients: recipients});
    }

    handleRecipientScopeChange(index, value) {
        let recipients = this.state.recipients.slice(0);
        recipients[index].scope = value;
        recipients[index].scopeError = false;
        recipients[index].scopeErrorMsg = '';
        if (typeof value !== "string" || value === '') {
            recipients[index].scopeError = true;
            recipients[index].scopeErrorMsg = 'Scope of Recipient is invalid';
        }
        this.setState({recipients: recipients});
    }

    onOrderValueChange(index, value){
        let recipients = this.state.recipients.slice(0);
        recipients[index].orderValue = value;
        this.setState({recipients: recipients});
    }

    handleRecipientElementNameChange(index,event){
        var options = event.target.options;
        var value = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(options[i].value);
            }
        }
        let recipient = Object.assign({},this.state.recipients[index])
        const recipients = Object.assign([],this.state.recipients)
        recipient.elements = value
        let foundDuplicate = this.validateDraggedelementName(recipient.elements,index)
        recipient.elementError = false;
        recipient.elementErrorMsg = '';
        if (foundDuplicate === true) {
            recipient.elementError = true;
            recipient.elementErrorMsg = 'You have assigned a element to multiple recipients';
        }
        recipients[index] = recipient

        this.setState({recipients:recipients})
    }
    handleRecipientIsRequesterChange(index, event){
        let _this = this;
        _this.setState(recipients => {
            let allRecipient =  _this.state.recipients;  // creating copy of state variable jasper
            allRecipient.map(function(recipient, index){
                recipient.isRequester = false;
                return null
            });
            return {recipients: allRecipient };
        });
        let recipient = Object.assign({},this.state.recipients[index])
        const recipients = Object.assign([],this.state.recipients)
        recipient.isRequester = true;
        recipients[index] = recipient;
        _this.setState({recipients:recipients});
    }

    handleAddRow() {
        let recipient = {
            index: this.state.recipients.length,
            name: '',
            email: '',
            scope: 'Signer',

            nameError: false,
            nameErrorMsg: '',

            emailError: false,
            emailErrorMsg: '',

            scopeError: false,
            scopeErrorMsg: '',

            elementsError: false,
            elementErrorMsg: ''
        }

        let recipients = this.state.recipients.slice(0);
        recipients.push(recipient);
        this.setState({recipients: recipients});
    }

    handleRemoveRow(index) {
        let recipients = this.state.recipients.filter(item => item.index !== index);
        recipients.map(function(item, index){
            item.index = index;
            return null
        });
        this.setState({recipients: recipients});
    }

    handleSubmit(event,draftState) {
        console.log("value== "+event);
        this.setState({redirectToList: event});
        var _this = this;
        var status=true
        if(draftState===false){
            status=false
        }
        if(!this.validateForm()) {
            return;
        }
        const jsonObj = {
            templateId:this.state.selectedTemplateId,
            emailTitle:this.state.emailTitle,
            description:this.state.description,
            eitherAchOrCardRequired:this.state.eitherAchOrCardRequired,
            enableSigningOrder:this.state.enableSigningOrder,
            processPaymentAfterSigning:this.state.processPaymentAfterSigning,
            staffId: this.state.staff.id,
            recipients:this.state.recipients,
            draftStatus:status,
            createOrderOnSigning: this.state.createOrderOnSigning,
            createInvoice: this.state.createInvoice,
            disableExportCustomer: this.state.disableExportCustomer

        };
        console.log("Json Object is ",jsonObj);
        this.setState({showLoader:true});
        fetch(this.props.api + '/signature', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify( jsonObj ) ,
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                //TODO show success message and redirect ot template list page
                console.log(json);
                console.log(json.isError);
                if (json && json.isError === false) {
                    const {apiStatus}  = this.state;
                    if (this.state.processPaymentAfterSigning === 'PROCESS_PAYMENT_AFTER_SIGNED' && (!this.state.blubillingConf || !this.state.blubillingConf.enablePayments)) {
                        this.setState({
                            rediretPage: true,
                            rdr: true,
                            id: json.eSignatureRequest.id
                        });
                    }else{
                        if(this.state.redirectToList === true){
                            this.setState({
                                rediretPage: true,
                                id:json.eSignatureRequest.id
                            });
                        }
                        else if(status===false){
                            this.setState({
                                rediretPage: true,
                                draftStatus: false,
                                id:json.eSignatureRequest.id
                            });

                        }
                        else{
                            console.log(json.url + '&token=' + _this.props.jwtToken);
                            window.open(json.url + '&token=' + _this.props.jwtToken, '_blank');
                            this.setState({
                                rediretPage: true,
                                id:json.eSignatureRequest.id
                            });
                        }
                        apiStatus.isError = false;
                        apiStatus.message = json.message
                    }
                } else {
                    const {apiStatus}  = this.state;
                    apiStatus.isError = true;
                    apiStatus.message = json.message
                    apiStatus.messages = json.messages
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    }
                }
                this.setState({showLoader:false});
            })
            .catch(error =>{
                console.log(error);
                this.setState({showLoader:false});
            });
    }

    validateForm() {

        const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        // must have at least 1 file

        let success = true;
        this.setState({emailTitleError:'',descriptionError:''})

        const {recipients} = this.state

        // validate the recipients
        let index = 0
        recipients.forEach((recipient) => {
            // every name must be a string
            recipient.nameError = false
            recipient.nameErrorMsg = ''

            recipient.emailError = false
            recipient.emailErrorMsg = ''

            recipient.scopeError = false
            recipient.scopeErrorMsg = ''

            recipient.elementsError = false
            recipient.elementErrorMsg = ''

            recipient.elementError =  false;
            recipient.elementErrorMsg =  ''

            if(typeof recipient.name !== "string" || recipient.name === '') {
                success = false
                recipient.nameError =  true;
                recipient.nameErrorMsg =  'Name of Recipients is invalid'
            }

            // every email must be a string and in a valid format

            if(typeof recipient.email !== "string" || recipient.email === '' || !emailPattern.test(recipient.email.toLowerCase())) {
                success = false
                recipient.emailError = true;
                recipient.emailErrorMsg = 'Email is invalid'
            }

            // every scope must be a string

            if(typeof recipient.scope !== "string" || recipient.scope === '') {
                success = false
                recipient.scopeError =  true;
                recipient.scopeErrorMsg =  'Scope is invalid'
            }

            let foundDuplicate = this.validateDraggedelementName(recipient.elements,index)
            if(foundDuplicate === true){
                success = false
                recipient.elementError =  true;
                recipient.elementErrorMsg =  'You have assigned a element to multiple recipients'
            }
            console.log("Elements "+recipient.elements);
            console.log("Elements -- "+recipient.elements !== "string" );
            if (recipient.elements === "string" && recipient.elements === '') {
                success = false
                recipient.elementError = true;
                recipient.elementErrorMsg = 'Elements are invalid'
            }
            index += 1;
        });

        if(this.state.description === '') {
            success = false
            this.setState({descriptionError:'Description is required'})
        }
        if(this.state.emailTitle === '') {
            success = false
            this.setState({emailTitleError:'Email Title is required'})
        }
        if (this.state.selectedTemplateId === '') {
            success = false
            this.setState({selectedTemplateIdError: 'Template is required'})
        }
        this.setState({recipients:recipients})
        return success;
    }

    validateDraggedelementName(selectedNames,donNotCheckIndex){
        let found = false
        const {recipients} = this.state
        console.log("recipients list ",recipients)
        console.log("Name List selected ", selectedNames)
        if(this.state.recipients && selectedNames){
            selectedNames.map(function(item, index){
                console.log("Name "+index, item)
                recipients.map(function(item1, index1){
                    console.log("Element map is donNotCheckIndex "+donNotCheckIndex+" and loop index is "+index1+" ",item1.elements)
                    if(donNotCheckIndex !== index1){
                        if(item1.elements){
                            item1.elements.map(function(item2, index2){
                                if(item2 && (item2 === item)){
                                    console.log("item2 map is ",item2)
                                    console.log("index2 map is ",index2)
                                    found = true
                                }
                                return null;
                            })
                        }
                    }
                    return null;
                })
                return null;
            })

        }
        console.log("Dragged Element found duplicate status ",found);
        return found
    }

    moveUp(index) {
        if (index > 0) {
            this._swap(this.state.recipients, index, index - 1);
        }
    }

    moveDown(index) {
        if (index < this.state.recipients.length - 1) {
            this._swap(this.state.recipients, index, index + 1);
        }
    }

    handleShowAdvanceOptions(){
        this.setState({showDiv: !this.state.showDiv})
    }

    _swap(obj, prop1, prop2) {
        let tmp = obj[prop1];
        obj[prop1] = obj[prop2];
        obj[prop2] = tmp;
        let index = 1;
        obj.forEach((recipient) => {
            recipient.orderValue = index;
            recipient.index = (index - 1);
            index += 1;
        });
        console.debug("After Swapping");
        console.debug(obj);
        this.setState({recipients:obj})
    }

    render() {
        let optionTag = "";
        let messageForConfig = "Payment processor configuration needs to be updated.";
        optionTag = this.state.templates.map(function (name, index) {
            return <option key={name.id} value={name.id}>{name.templateName}</option>;
        });

        /**
         * here we are displaying the error msg when 2 dragged elements are identical and assigned to 2 different recipients
         * (identical elements should be assigned to same recipients)
         * @type {any[]}
         */
            const elementErrorMsgs = this.state.recipients.map((recipient, index) => (
            <div>
                <span style={{ color: 'red' }}>{recipient.elementErrorMsg}</span>
            </div>
        ));

        let _this = this;
        return (
            <div className="wrapper animated fadeInRight">
                <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                      redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                {(this.state.rediretPage && this.state.rediretPage === true) ? (
                    <Redirect to={_this.state.rdr  === true ? '/paymentProcessorConfiguration/'+messageForConfig : `/esignatureDetail/${_this.state.id}`}/>) : null}
                <div className="row">
                    {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">{_this.props.msg('getSignature.header1')}</p>
                            </div>

                            <div>{elementErrorMsgs}</div>

                            <div className="table-box table-responsive p-m" style={{minHeight:"490px"}}>
                                <Errors errorObject={this.state.apiStatus}/>
                                <form className="form-horizontal">

                                    <div className="form-group" style={{marginBottom:"5px"}}>
                                        <label className="col-lg-2 control-label">{_this.props.msg('form.label.chooseTemplate')}</label>

                                        <div className="col-lg-10">
                                            <select className="form-control scopecls" name="scope"
                                                    value={this.state.selectedTemplateId}
                                                    onChange={this.onChangeTemplate}>
                                                <option value="">Select Template</option>
                                                {optionTag}
                                            </select>
                                            <span style={{color:'red'}}>{this.state.selectedTemplateIdError}</span>
                                        </div>
                                    </div>
                                    {this.state.globalEnableSigningOrder === true ? <div className="form-group">
                                        <label className="col-lg-2 control-label">{_this.props.msg('form.label.signingOrder')}</label>
                                        <div className="col-lg-10">
                                            <input
                                                type="checkbox" id="enableSigningOrder" name="enableSigningOrder"
                                                checked={_this.state.enableSigningOrder === true ? true : false}
                                                onChange={(e)=>_this.checkBoxChange(_this.state.enableSigningOrder, 'enableSigningOrder')}/>
                                        </div>
                                    </div> : null}

                                    <Recipients
                                        recipients={this.state.recipients}
                                        onAddRow={this.handleAddRow}
                                        onRemoveRow={this.handleRemoveRow}
                                        onRecipientNameChange={this.handleRecipientNameChange}
                                        onRecipientAccessCodeChange={this.handleRecipientAccessCodeChange}
                                        onRecipientEmailChange={this.handleRecipientEmailChange}
                                        onRecipientScopeChange={this.handleRecipientScopeChange}
                                        onRecipientElementNameChange={this.handleRecipientElementNameChange}
                                        onRecipientIsRequesterChange = {this.handleRecipientIsRequesterChange}
                                        msg={_this.props.msg}
                                        enableSigningOrder = {this.state.enableSigningOrder}
                                        moveUp = {this.moveUp}
                                        moveDown = {this.moveDown}
                                    />

                                    <div className="form-group" style={{marginBottom:"5px"}}>
                                        <label className="col-lg-2 control-label">{_this.props.msg('form.label.subject')}</label>

                                        <div className="col-lg-10">
                                            <input type="text"
                                                   className="form-control"
                                                   id="emailTitle"
                                                   name="emailTitle"
                                                   value={this.state.emailTitle}
                                                   onChange={this.handleChange}/>
                                            <span style={{color:'red'}}>{this.state.emailTitleError}</span>
                                        </div>
                                    </div>
                                    <div className="form-group" style={{marginBottom:"5px"}}>
                                        <label className="col-lg-2 control-label">{_this.props.msg('form.label.emailBody')}</label>

                                        <div className="col-lg-10">
                                        <textarea className="form-control"
                                                  type="text"
                                                  id="description"
                                                  name="description"
                                                  onChange={this.handleChange}
                                                  value={this.state.description}/>
                                            <span style={{color:'red'}}>{this.state.descriptionError}</span>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-lg-2 control-label"></label>
                                        <div className="col-lg-10">
                                            <a style={{textDecoration:'underline'}}
                                               onClick={this.handleShowAdvanceOptions}>Show / Hide Advanced Options</a></div>
                                    </div>
                                    <div id="getsignatureRequest" style={{display:this.state.showDiv===false?'none':'block'}}>
                                        {_this.state.globalEnableCreateCustomer === true ?
                                            <div className="form-group" style={{marginBottom:"5px"}}>
                                                <label className="col-lg-2 control-label" style={{paddingTop:"0px"}}>{_this.props.msg('table.th.createCreateCustomerOnSigning')}</label>
                                                <div className="col-lg-10">
                                                    <input type="checkbox" id="disableExportCustomer" name="disableExportCustomer"
                                                           checked={_this.state.disableExportCustomer === true ? true: false}
                                                           onChange={(e)=>_this.checkBoxChange(_this.state.disableExportCustomer, 'disableExportCustomer')}/>
                                                    &nbsp;&nbsp;{_this.props.msg('table.th.createCustomerOnSigningInfo')}
                                                </div>
                                            </div>:''
                                        }
                                        {_this.state.allowCreateOrder === true ?
                                            <div className="form-group" style={{marginBottom:"5px"}}>
                                                <label className="col-lg-2 control-label">{_this.props.msg('table.th.createOrderOnSigning')}</label>
                                                <div className="col-lg-10">
                                                    <input type="checkbox" id="createOrderOnSigning" name="createOrderOnSigning"
                                                           checked={_this.state.createOrderOnSigning === true ? true : false}
                                                           onChange={(e)=>_this.checkBoxChange(_this.state.createOrderOnSigning, 'createOrderOnSigning')}/>
                                                    &nbsp;&nbsp;{_this.props.msg('table.th.createOrderOnSigningInfo')}
                                                </div>
                                            </div>:''
                                        }
                                        {_this.state.allowCreateOrder === true ?
                                            <div className="form-group" style={{marginBottom:"5px"}}>
                                                <label className="col-lg-2 control-label">{_this.props.msg('table.th.createInvoice')}</label>
                                                <div className="col-lg-10">
                                                    <input type="checkbox" id="createInvoice" name="createInvoice"
                                                           checked={_this.state.createInvoice === true ? true : false}
                                                           onChange={(e)=>_this.checkBoxChange(_this.state.createInvoice, 'createInvoice')}/>
                                                    &nbsp;&nbsp;{_this.props.msg('table.th.createInvoiceInfo')}
                                                </div>
                                            </div>:''
                                        }


                                        <div className="form-group" style={{marginBottom:"5px"}}>
                                            <label className="col-lg-2 control-label">{_this.props.msg('table.th.achCardOptional')}</label>
                                            <div className="col-lg-10">
                                                <input type="checkbox" id="eitherAchOrCardRequired" name="eitherAchOrCardRequired"
                                                       checked={_this.state.eitherAchOrCardRequired === true ? true : false}
                                                       onChange={(e)=>_this.checkBoxChange(_this.state.eitherAchOrCardRequired, 'eitherAchOrCardRequired')}/>
                                                &nbsp;&nbsp;{_this.props.msg('table.th.achCardOptionallabel')}
                                            </div>
                                        </div>
                                        <div className="form-group" style={{marginBottom:"5px",display: (this.state.globalProcessPaymentAfterSigning === true ? 'block': 'none')}}>
                                            <label className="col-lg-2 control-label">{_this.props.msg('table.th.processPayment')}</label>
                                            <div className="col-lg-10">
                                                <label className="radio-inline" style={{display:'block'}}>
                                                    <input
                                                        type="radio" id="processPaymentAfterSigning" name="processPaymentAfterSigning"
                                                        checked={_this.state.processPaymentAfterSigning === 'PROCESS_PAYMENT_AFTER_SIGNED'? true : false}
                                                        onChange={(e)=>_this.changeRadioButton('PROCESS_PAYMENT_AFTER_SIGNED',  'processPaymentAfterSigning')}/>{_this.props.msg('table.th.processPaymentlabel')}
                                                </label>
                                                <label className="radio-inline" style={{marginLeft:'0px'}}>
                                                    <input
                                                        type="radio" id="processPaymentAfterSigning" name="processPaymentAfterSigning"
                                                        checked={_this.state.processPaymentAfterSigning === 'DISABLED' ? true: false}
                                                        onChange={(e)=>_this.changeRadioButton('DISABLED', 'processPaymentAfterSigning')}/> {_this.props.msg('table.th.disableProcessPaymentlabel')}
                                                </label>
                                            </div>
                                        </div>
                                        <div className="form-group" style={{marginBottom:"5px"}}>
                                            <label className="col-lg-2 control-label">{_this.props.msg('getSignature.donotemailattachment')}</label>
                                            <div className="col-lg-10">
                                                <input type="checkbox" id="doNotEmailAttachment" name="doNotEmailAttachment"
                                                       checked={_this.state.doNotEmailAttachment === true ? true : false}
                                                       onChange={(e)=>_this.checkBoxChange(_this.state.doNotEmailAttachment, 'doNotEmailAttachment')}/>
                                                &nbsp;&nbsp;{_this.props.msg('getSignature.donotemailattachmentdesc')}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group" style={{marginBottom:"5px"}}>
                                        <div className="col-lg-offset-2 col-lg-10">
                                            <Link to="/template/list" className="btn btn-white">{_this.props.msg('form.label.cancelButton')}</Link>
                                            &nbsp;&nbsp;&nbsp;
                                            <button className="btn btn-primary" type="button" onClick={(e)=>this.handleSubmit(false,true)}>
                                                {_this.props.msg('form.label.saveAndSend')}
                                            </button>
                                            <button title={"Bypass all previews and send immediately"} className="btn btn-primary" type="button" style={{marginLeft:"5px"}} onClick={(e)=>this.handleSubmit(false,false)}>
                                                Quick Send
                                            </button>
                                            &nbsp;&nbsp;&nbsp;
                                            <input className="btn btn-default" type="button"
                                                   onClick={(e)=>this.handleSubmit(true,true)} value={_this.props.msg('form.label.saveDraftSendLater')}/>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default GetSignature;


// WEBPACK FOOTER //
// ./src/components/template/GetSignature.js